import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import ModalPrompt from "@/app/components/ui/Modals/Prompt";
import { IClinicToClinicPostTransferOrderBody } from "@/api_framework/api_modals/Inventory";
import { useEffect, useState } from "react";
import { IInventoryState } from "@/app_redux/reducers/slices/auth/inventory_slice";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useCreateTransferOrderAPI } from "@/app/hooks/api_hooks/Inventory/ClinicToClinicTransfer/useCreateTransferOrderAPI";

const TOSelectedItemModalContent = ({ transferInventoryItems }) => {
  return (
    <div>
      <div className="mt-5 mr-2 h-[500px] overflow-y-auto">
        <table className="border rounded-md divide-y divide-gray-200 w-full shadow-md">
          <thead className="top-0 sticky bg-[rgb(244,248,255)]">
            <tr>
              <th className="px-3 py-3 font-medium text-black text-left text-sm">Product Name</th>
              <th className="px-3 py-3 font-medium text-black text-left text-sm whitespace-nowrap">Lot</th>
              <th className="px-3 py-3 font-medium text-black text-left text-sm whitespace-nowrap">Manufacturer</th>
              <th className="px-3 py-3 font-medium text-black text-left text-sm">Expiry</th>
              <th className="px-3 py-3 font-medium text-black text-left text-sm whitespace-nowrap">MRP</th>
              <th className="px-3 py-3 font-medium text-black text-left text-sm whitespace-nowrap">Qty</th>
              <th className="px-3 py-3 font-medium text-black text-left text-sm whitespace-nowrap">Transfer Qty</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-orange-100">
            {transferInventoryItems?.selectedItems?.map((item, i) => (
              <tr key={i}>
                <td className={"px-3 py-4 text-xs font-normal text-left"}>
                  <p className="w-[235px]">{item.product_name}</p>
                </td>
                <td className={"px-3 py-4 text-xs font-normal text-left"}>
                  <p>{item.lot_number}</p>
                </td>
                <td className={"px-3 py-4 text-xs font-normal text-left"}>
                  <p>{item.manufacturer_name}</p>
                </td>
                <td className={"px-3 py-4 text-xs whitespace-nowrap font-normal text-left"}>
                  <p>{item.expiry_date}</p>
                </td>
                <td className={"px-3 py-4 text-xs font-normal text-left"}>
                  <p>{item.mrp}</p>
                </td>
                <td className={"px-3 py-4 text-xs font-normal text-left"}>
                  <p>{item.quantity}</p>
                </td>
                <td className={"px-3 py-4 text-xs font-normal text-left"}>
                  <p>{item.transferQty}</p>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const TOSelectedItemModal = () => {
  const { setInvisible } = useModalActions("TO_SELECTED_ITEM_MODAL");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { getRouteKey } = useRouter();
  const { toNumber, transferInventoryItems } = useRouteInfo(getRouteKey("INVENTORY", "id")).routeState
    .state as IInventoryState;
  const createTransferOrder = useCreateTransferOrderAPI();
  const storedOrderNumber = localStorage.getItem("transfer_order_number");

  useEffect(() => {
    if (toNumber?.transfer_order_id) {
      localStorage.setItem("transfer_order_id", toNumber?.transfer_order_id);
    }
  }, [toNumber]);

  const storedOrderId = localStorage.getItem("transfer_order_id");

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await createTransferOrder({
        sender_clinic_details: {
          sender_clinic_id: transferInventoryItems?.senderClinic?.id,
          sender_clinic_name: transferInventoryItems?.senderClinic?.name,
        },
        receiver_clinic_details: {
          receiver_clinic_id: transferInventoryItems?.receiverClinic?.id,
          receiver_clinic_name: transferInventoryItems?.receiverClinic?.name,
        },
        inventory_type: transferInventoryItems?.type == "good" ? "Good" : "Bad",
        order_id: toNumber?.transfer_order_id || storedOrderId,
        order_number: toNumber?.transfer_order_number || storedOrderNumber,
        transfer_order_data: transferInventoryItems?.selectedItems.map((s) => {
          const transferItem: IClinicToClinicPostTransferOrderBody = {
            product_id: s.vetic_variant_id,
            product_name: s.product_name,
            transfer_qty: +s.transferQty,
            lot_number: s.lot_number,
            manufacturer_name: s.manufacturer_name,
            expiry_date: s.expiry_date,
            mrp: s.mrp !== null ? +s.mrp : null,
            grn_id: s.grn_id,
            sub_grn_id: s.sub_grn_id,
            unique_row_id: s.unique_row_id,
          };
          if (transferInventoryItems?.type === "bad") {
            transferItem.bad_inventory_id = s.bad_inventory_id;
          }
          return transferItem;
        }),
      });
      setIsSubmitting(false);
      setInvisible();
      localStorage.removeItem("clinic_tams");
      localStorage.removeItem("senderClinic");
    } catch (error) {
      setIsSubmitting(false);
    }
  };

  return (
    <ModalPrompt
      modalId="TO_SELECTED_ITEM_MODAL"
      showIcon={false}
      titleIcon=""
      dialogClassName="sm:my-8 sm:w-full sm:max-w-6xl sm:p-6 flex flex-col"
      title="Transfer Order Selected Items"
      button={{
        primaryButtonText: "",
        secondaryButtonText: "",
        primaryButtonDisabled: true,
        primaryButtonClassname: "!bg-white !mt-[0px] !sm:mt-[0px] !py-0",
      }}
      content={
        <div className="flex flex-col h-full">
          <div className="flex-1 pr-2">
            <TOSelectedItemModalContent transferInventoryItems={transferInventoryItems} />
          </div>
          <div className="sticky bottom-0 pt-4">
            <div className="flex justify-end gap-4">
              <button
                className="px-6 py-[9px] rounded-md border border-slate-400 bg-white"
                onClick={() => {
                  setInvisible();
                }}
              >
                Cancel
              </button>
              <button
                className={`px-6 py-[9px] rounded-md border border-slate-400 text-white ${
                  isSubmitting ? "bg-gray-400 cursor-not-allowed" : "bg-[#193A6A] cursor-pointer"
                }`}
                onClick={() => handleSubmit()}
              >
                Create TO
              </button>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default TOSelectedItemModal;
